import {
  TransferItemAPITypes,
  TransferItemUITypes,
} from '@app/constant/transfer-item-types';
import I18n from '@module/i18n';

const createBareTree = (name) => ({
  uiType: TransferItemUITypes.directory,
  name,
  map: {},
  items: [],
});

const addBranchToTree = (tree, branch, item) => {
  const nodeName = branch.shift();

  if (branch.length) {
    let subTree = tree.map[nodeName];

    if (!subTree) {
      subTree = createBareTree(nodeName);
      tree.map[nodeName] = subTree;
      tree.items.push(subTree);
    }

    addBranchToTree(subTree, branch, item);
  } else {
    tree.map[nodeName] = item;
    tree.items.push(item);
  }
};

const getSubNodesFromItemName = (itemName) => {
  /**
   * Forward slash is always used as a separator
   * Also it is not possible to have it as a part of file-system-entry name
   */
  return itemName.split('/');
};

const getItemsWithUITypes = (items = []) =>
  items.map((item) => ({
    ...item,
    uiType:
      item.apiType === TransferItemAPITypes.empty_directory
        ? TransferItemUITypes.directory
        : TransferItemUITypes.file,
  }));

const buildItemsTree = (items = []) => {
  const tree = createBareTree('/');

  items.forEach((item) => {
    const branch = getSubNodesFromItemName(item.name);
    addBranchToTree(tree, branch, item);
  });

  return tree;
};

const shouldDisplayItemsCounter = (numberOfItems, numberOfDisplayedItems) =>
  numberOfItems > numberOfDisplayedItems;

const renderExpireMessage = (expirySeconds) => {
  return !expirySeconds
    ? I18n.t('transfer.download.expires_never')
    : I18n.t('transfer.download.expires', {
        relative_time: I18n.relativeTime(expirySeconds),
      });
};

const moreThanADayAgo = (uploadDate) =>
  new Date().getTime() - uploadDate.getTime() > 24 * 60 * 60 * 1000;

const renderDateTime = (uploaded_at, type = 'sent') => {
  const uploadDate = new Date(uploaded_at);
  return moreThanADayAgo(uploadDate)
    ? I18n.t(`page.transfer.${type}_datetime`, {
        date: I18n.date(uploadDate, 'without_day'),
        time: I18n.time(uploadDate),
      })
    : I18n.t(`page.transfers.${type}_time_ago`, {
        timeAgo: I18n.relativeTime(uploadDate),
      });
};

const renderDate = (uploaded_at, type = 'sent') => {
  const uploadDate = new Date(uploaded_at);
  return moreThanADayAgo(uploadDate)
    ? I18n.t(`page.transfer.${type}_moment`, {
        moment: I18n.date(uploadDate, 'without_day'),
      })
    : I18n.t(`page.transfers.${type}_time_ago`, {
        timeAgo: I18n.relativeTime(uploadDate),
      });
};

function getDeepSubItems(item) {
  return (item.items || []).reduce((result, subItem) => {
    if (subItem.items) {
      return [...result, ...getDeepSubItems(subItem)];
    }

    return [...result, subItem];
  }, []);
}

export {
  getItemsWithUITypes,
  buildItemsTree,
  getSubNodesFromItemName,
  shouldDisplayItemsCounter,
  moreThanADayAgo,
  renderExpireMessage,
  renderDate,
  renderDateTime,
  getDeepSubItems,
};
